import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SensorsDataContextType {
    student_id: number;
    current_projectid: number;
    current_projectname: string;
}

const SensorsDataContext = createContext<SensorsDataContextType | undefined>(undefined);

export default SensorsDataContext;
